import { connect } from 'react-redux';
import ScriptFertilizerApplicationModal from './ScriptFertilizerApplicationModal';
import { scriptTypes, applicationProperties } from '../constants/scripts';
import { validateZoneApplicationProperty } from '../current/validators';

// selectors
import { isAppMode } from 'settings/selectors';
import { 
  transformFertilizerRateToNitrogen, 
  transformNitrogenRateToFertilizer,
  getFormatForProduct 
} from 'products/fertility-selectors';
import {
  getProductValidationValues
} from 'user/selectors';
import {
  getActiveKeypad,
  isZoneEditingDisabled,
  getActiveScriptType
} from 'current/selectors';
import { getActiveCropId } from 'current/currentSelectors';
import { getProductsForScript } from 'scripts/selectors';
import { 
  getFertilityProductSubstanceSetForScript 
} from 'scripts/fertility-selectors';
import { getFormatFromApplicationIncorporationMethod } from 'products/selectors';
import { getIncorporationMethodForScript } from 'scripts/application-selectors';

// actions
import { updateProductApplicationProperty } from 'scripts';


export default connect(
  (state, ownProps) => {
    const { script } = ownProps;

    const scriptType = getActiveScriptType(state);
    const cropId = getActiveCropId(state);
    let format;
    let substanceSet;
    if (scriptType === scriptTypes.FERTILITY) {
      const [product] = getProductsForScript(script);
      format = getFormatForProduct(product);
      substanceSet = getFertilityProductSubstanceSetForScript(script);
    } else if (scriptType === scriptTypes.APPLICATION) {
      format = getFormatFromApplicationIncorporationMethod(getIncorporationMethodForScript(script));
      substanceSet = getFertilityProductSubstanceSetForScript(script);
    }
    const property = applicationProperties.NITROGEN_RATE;
    const productValidationValues = getProductValidationValues(state);

    const validateRate = value => {
      const validation = validateZoneApplicationProperty({
        cropId,
        format,
        property,
        scriptType,
        substanceSet,
        productValidationValues,
        value
      });
      if (validation[applicationProperties.NITROGEN_RATE]) { 
        // If value is not valid, return a proper validationResult object
        return {
          isInvalid: true,
          resultedFromUserInput: true,
          helpMessages: validation[applicationProperties.NITROGEN_RATE]
        };
      }
      return {
        isInvalid: false
      };
    };

    return {
      isAppMode: isAppMode(state),
      activeKeypad: getActiveKeypad(state),
      isEditingDisabled: isZoneEditingDisabled(state),
      validateRate,
      transformFertilizerRateToNitrogen: (fertilizerRate) =>
        transformFertilizerRateToNitrogen(state, script, fertilizerRate),      
      transformNitrogenRateToFertilizer: (nitrogenRate) => 
        transformNitrogenRateToFertilizer(state, script, nitrogenRate)
    };
  },
  (dispatch, ownProps) => {
    const { script } = ownProps;
    const scriptId = script.id;
    const zones = Object.keys(script.zones);
    return {
      onChangeProductApplication: ({ value, property }) => {
        zones.forEach(zoneId => 
          dispatch(updateProductApplicationProperty({ property, scriptId, value, zoneId }))
        );
      }
    };
  }
)(ScriptFertilizerApplicationModal);
